import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "vld-parent" }

import Loading from 'vue3-loading-overlay/dist/index';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import { storeToRefs } from 'pinia';
import { useLoadingDialogStore } from '@/stores/useLoadingDialogStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingDialog',
  setup(__props) {

const loadingDialog = useLoadingDialogStore();
const { active } = storeToRefs(loadingDialog);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Loading), {
        active: _unref(active),
        "can-cancel": false,
        color: "#1b7ec0",
        "bg-color": "#fff",
        "is-full-page": true,
        "z-index": 9999
      }, null, 8, ["active"])
    ])
  ]))
}
}

})